import React from "react";
import i18n from "utils/i18n";
import _ from 'lodash'
import ThemedBlock from 'components/atoms/ThemedBlock'
import Form, { createTranslationField } from 'components/molecules/Form'
import HelperManagementRights from 'utils/helper-management-rights'
import { managementRightsConstants } from 'utils/constants/management-right-constants'
import { useSelector } from 'react-redux'
import { dataConstants } from 'services/redux/data/constants'
import { FormFieldsConstants } from 'utils/constants/form-constants'

const ManagementTimeslotGroupBasicTab = ( { saveForm, updateTimeslotGroup, timeslotGroup, isSaving }) => {

	const _languages = useSelector( state => {
		return state.data[dataConstants.LANGUAGES];
	} )
	
	const formFields = [
		{
			name: 'name',
			label: i18n.t('management:form.name.system_name'),
			type: FormFieldsConstants.TEXT,
		},
		{
			name: 'active',
			label: i18n.t('management:form.active.title'),
			type: FormFieldsConstants.SELECT_ACTIVE
		},
	];
	
	// Add the translations
	if( _.size( _languages ) > 0 ) {
		formFields.push( {
			type: FormFieldsConstants.DIVIDER
		} );
		
		// Add the translation fields
		_.forEach( _languages, ( language ) => {
			let { name, formField } = createTranslationField( 'name', language );
			formFields.push( formField );
			
			const { name: descriptionName, formField: descriptionFormField } = createTranslationField( 'description', language );
			formFields.push( descriptionFormField );
		});
	}
	
	return (
		<ThemedBlock
			shadow
			mediumPadding>
			
			<Form
				values={ timeslotGroup }
				fields={ formFields }
				onChange={ updateTimeslotGroup }
				onSubmit={ saveForm }
				disabled={ !HelperManagementRights.hasEditRight( managementRightsConstants.EDIT.TIMESLOTS ) || isSaving }
				forceSaveButton={ true }
			/>
		</ThemedBlock>
	);
}


export default ManagementTimeslotGroupBasicTab
